import { BioSamplingSupplyContainerV1 } from '@csp/dmdp-api-hbs-supply-dto';
import { BioSampleContainer } from '@csp/csp-common-hbs-model';
import { AuditMapper } from '@csp/csp-common-mapper';
import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';

const toContainer = (v1: BioSamplingSupplyContainerV1): BioSampleContainer => {
  const kitExpiration = v1.kitExpirationDate
    ? ZonedDateTimeFactory.fromZonedDateTimeString(v1.kitExpirationDate)
    : undefined;
  const isExpired = kitExpiration?.unixTimeMillis ? kitExpiration?.unixTimeMillis < Date.now() : false;

  return {
    audit: v1.audit ? AuditMapper.fromV1(v1.audit) : undefined,
    eventId: v1.eventId,
    sampleContainerCode: v1.containerCode,
    kitCode: v1.kitCode,
    containerNumber: v1.containerNumber,
    dCode: v1.dCode,
    kitType: v1.kitType,
    siteNumber: v1.practiceCode,
    kitExpirationDateStr: v1.kitExpirationDate,
    kitExpiration,
    isExpired,
    containerType: v1.containerType,
    containerDescription: v1.containerDescription,
    kitDescription: v1.kitDescription,
    containerAnalyteType: v1.labelInformation,
    containerSampleType: v1.sampleType,
  };
};

const toContainers = (v1s: BioSamplingSupplyContainerV1[]): BioSampleContainer[] => v1s.map(toContainer);

export const BioSampleContainerMapper = {
  toContainer,
  toContainers,
};
